module.exports = __webpack_public_path__ + "static/monkey_1920-40-bd722c670219660ad9c643b3476fa621.jpg";